export const BaseRoute = "/";
